import axiosInstance from './axios';

export const waymarkerApi = {
    getWaymarkers: async function({ raceStageId, incidentId, distanceM, gpxFile } = {}) {
        try {
            const params = new URLSearchParams();
            if (raceStageId) params.append('race_stage_id', raceStageId);
            if (incidentId) params.append('incident_id', incidentId);

            if (gpxFile) {
                const formData = new FormData();
                formData.append('gpx', gpxFile);
                if (raceStageId) formData.append('race_stage_id', raceStageId);
                if (incidentId) formData.append('incident_id', incidentId);
                if (distanceM !== undefined && distanceM !== null && String(distanceM).trim() !== '') {
                    formData.append('distance_m', distanceM);
                }

                const response = await axiosInstance.post('/waymarkers', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                return response.data;
            }

            const query = params.toString();
            const response = await axiosInstance.get(`/waymarkers${query ? `?${query}` : ''}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching waymarkers:', error);
            throw error;
        }
    },
    syncWaymarkers: async function() {
        try {
            await axiosInstance.get(`/waymarkers/sync`);
            return;
        } catch (error) {
            console.error('Error syncing waymarkers:', error);
            throw error;
        }
    },
    deleteWaymarker: async function(waymarkerId) {
        try {
            const response = await axiosInstance.delete(`/waymarkers/${waymarkerId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting waymarker:', error);
            throw error;
        }
    }
};
